// NetSpeedPro/index.jsxx
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';

import Carosel from '../components/home/carosel';
import Services from '../components/home/services';
import Business from '../components/home/business';
import Paket from '../components/home/paket';
import Pelanggan from '../components/home/pelanggan';
import Mitra from '../components/home/mitra';
import Peta from '../components/home/peta';
import Footer from '../components/footer/index';
import Gallery from '../components/home/gallery';
import News from '../components/home/berita';
import AcehProviderLanding from '../components/home/icon-masjid';
import { useDarkMode } from '../components/darkmode/DarkModeContext';
import { useAuth } from '../pages/auth/AuthContext'; // Import useAuth
import BusinessSolutions from '../components/home/internet-business';
import SubscriptionSteps from '../components/home/tata_cara_berlangganan';
import AIAssistantFloat from '../components/home/chatbot/FloatingChatAssistant';
import CustomerChat from './chat/CustomerChat';
import L from 'leaflet';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const NetSpeedPro = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [emailSubscription, setEmailSubscription] = useState('');
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  
  // Gunakan dark mode dari context
  const { isDarkMode } = useDarkMode();
  
  // Gunakan auth context untuk cek status login
  const { isAuthenticated, loading } = useAuth();

  // Effect untuk menampilkan popup setelah halaman dimuat
  useEffect(() => {
    if (!isAuthenticated && !loading) {
      // Cek apakah popup sudah pernah ditampilkan dalam session ini
      const popupShown = sessionStorage.getItem('promoPopupShown');
      
      if (!popupShown) {
        // Tampilkan popup setelah 2 detik
        const timer = setTimeout(() => {
          setShowPromoPopup(true);
        }, 2000);

        return () => clearTimeout(timer);
      }
    }
  }, [isAuthenticated, loading]);

  // Handler untuk menutup popup
  const handleClosePopup = () => {
    setShowPromoPopup(false);
    // Simpan ke sessionStorage agar popup tidak muncul lagi dalam session ini
    sessionStorage.setItem('promoPopupShown', 'true');
  };

  // Show loading while checking auth status
  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900' : 'bg-gray-100'
      }`}>
        <div className="flex flex-col items-center space-y-4">
          <div className={`animate-spin w-12 h-12 border-4 border-t-transparent rounded-full ${
            isDarkMode ? 'border-green-500' : 'border-blue-500'
          }`}></div>
          <p className={isDarkMode ? 'text-gray-300' : 'text-gray-600'}>
            Memuat...
          </p>
        </div>
      </div>
    );
  }

  // Redirect to dashboard if user is authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div
      className={`min-h-screen flex flex-col font-sans w-full transition-colors duration-300`}
      style={{
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : ' #dfe4e0ff',
        color: isDarkMode ? '#F9FAFB' : '#111827',
        backgroundBlendMode: 'overlay' 
      }}
    >
      <AIAssistantFloat />

      <div className="pt-20">
        {/* Carousel */}
        <Carosel />
        
        {/* Service Categories */}
        <Services />

        <BusinessSolutions />

        {/* Popular Packages */}
        <Paket />

        <SubscriptionSteps />

        <Gallery />

        <News />

        <div className="py-16">
          <div className="section-container">
            <div className="text-center mb-8">
              <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Area Cakupan Layanan
              </h2>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Kami terus memperluas jangkauan layanan ke seluruh wilayah Aceh
              </p>
            </div>
            <Peta />
          </div>
        </div>
        
        {/* Partners */}
        <Mitra />
      </div>
      
      {/* Footer */}
      <Footer />
      <CustomerChat />
    </div>
  );
};

export default NetSpeedPro;